<template>
  <div class="container">
    <div>
      <Visualizar />
    </div>

    <b-row>
      <b-col class="one">
        <Moda
          :title="title"
          :text="text"
          :text_Two="text_Two"
          :text_One="text_One"
          :text_three="text_three"
        />
      </b-col>
      <b-col class="btn-direction-flex">
        <b-button
          @click="guardarBorrador"
          pill
          variant="primary"
          class="btn-one"
          v-if="userPermissions"
        >
          Guardar como borrador
        </b-button>
        <b-button
          @click="guardarFinalizado"
          pill
          variant="primary"
          class="btn-two"
          v-if="userPermission"
        >
          Guardar y finalizar
        </b-button>
      </b-col>
    </b-row>

    <b-row>
      <b-col class="title">
        <h5>Presentación del Servicio - Resumen Ejecutivo</h5>
      </b-col>
    </b-row>
    <b-row v-if="cargado_borrador">
      <CkEditorText :modifyContent="modifyContent" :borrador="borrador" />
    </b-row>
  </div>
</template>

<script>
import Visualizar from "../../../../components/button/escritorio/Visualizar.vue";
import Moda from "../../../../components/tools/Modal";
import CkEditorText from "../../../../components/private/CkEditorText";
import { showAlert } from "../../../../components/tools/utils";
import Swal from "sweetalert2";

import axios from "axios";

export default {
  props:["userPermissions", "userPermission"],

  components: {
    Visualizar,
    Moda,
    CkEditorText,
  },
  data() {
    return {
      borrador:"",
      cargado_borrador:false,
      content: "",
      nombre: "presentacion_servicio",
      datosUser: null,
      title: "Resumen Ejecutivo",
      text:
        "Breve descripción del Servicio, señalando su razón de ser, las funciones que desempeñan, los clientes que atiende, así como también una breve reseña de su estructura organizacional; número de funcionarios, número de oficinas regionales, entre otros aspectos que sea relevante destacar. Puede hacer referencia a las secciones “Quiénes somos”, “Recursos Humanos” y “Recursos Financieros” ",
      text_Two:
        "Hacer una breve descripción del tamaño de la institución, medido según: presupuesto en moneda nacional, como % del PIB (si corresponde), como % del gasto público, como % del gasto del Ministerio; dotación total, y por variables relevantes como tipo de contrato, sexo, tipo de cargo, y como porcentaje de la dotación total del ministerio.",
      text_One:
        "Describir en un relato claro y preciso un resumen de los principales resultados del desempeño (logros y no logros) de la institución en el año 2020 con base en la información presentada en el Capítulo 3 “Resultados de la Gestión 2020”, señalando las principales circunstancias o factores internos y externos que han afectado el desempeño institucional, y las medidas a adoptar, cuando corresponda. ",
      text_three:
        "Finalmente, presentar una breve descripción de los desafíos para el año 2018-2022, señalados en detalle en el capítulo 4.",
    };
  },

  methods: {
    modifyContent: function(text) {
      this.content = text;
    },
    buildData: function(type) {
      return {
        nombre: this.nombre,
        elaboracion: type,
        data: {
          content: this.content,
        },
        anio: process.env.VUE_APP_ANIO,
        idServicio: this.$route.params.idServicio,
      };
    },
    guardarBorrador: async function() {
      try {
        const toSend = this.buildData("borrador");

        await axios.post(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/`,
          toSend,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );
        showAlert({
          icon: "success",
          text: "Guardado como Borrador Exitoso",
          timerProgressBar: true,
          timer: 3000,
        });
      } catch (error) {
        if (error.response.status === 422) {
          const toSend = {
            nombre: this.nombre,
            elaboracion: "borrador",
            data: {
              content: this.content,
            },
            anio: process.env.VUE_APP_ANIO,
          };

          await axios.put(
            `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/`,
            toSend,
            {
              headers: {
                Authorization: `JWT ${localStorage.getItem("userToken")}`,
              },
            }
          );
          showAlert({
            icon: "success",
            text: "Guardado como Borrador Exitoso",
            timerProgressBar: true,
            timer: 3000,
          });

          this.$router.push({
            name: "bgi",
            params: { idUsuario: this.usuario.id },
          });
        } else {
          console.log(error);
          showAlert({
            icon: "error",
            text: error.response.data[Object.keys(error.response.data)[0]],
            timerProgressBar: true,
            timer: 3000,
          });
        }
      }
    },
    guardarFinalizado: async function() {
      Swal.fire({
        title: "Guardar y Finalizar",
        text: "¿Desea guardar el documento?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Confirmar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const toSend = this.buildData("finalizado");

            await axios.post(
              `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/`,
              toSend,
              {
                headers: {
                  Authorization: `JWT ${localStorage.getItem("userToken")}`,
                },
              }
            );
            showAlert({
              icon: "success",
              text: "Guardando documento",
              timerProgressBar: true,
              timer: 3000,
            });
          } catch (error) {
            if (error.response.status === 422) {
              const toSend = {
                nombre: this.nombre,
                elaboracion: "finalizado",
                data: {
                  content: this.content,
                },
                anio: process.env.VUE_APP_ANIO,
              };

              await axios.put(
                `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/`,
                toSend,
                {
                  headers: {
                    Authorization: `JWT ${localStorage.getItem("userToken")}`,
                  },
                }
              );
              showAlert({
                icon: "success",
                text: "Documento Guardado ",
                timerProgressBar: true,
                timer: 3000,
              });
            } else {
              console.log(error);
              showAlert({
                icon: "error",
                text: error.response.data[Object.keys(error.response.data)[0]],
                timerProgressBar: true,
                timer: 3000,
              });
            }
          }
          this.$router.push({
            name: "buttons",
            params: { idUsuario: this.usuario.id },
          });
        }
      });
    },
    obtenerBorrador: async function() {
      try {
        const obj = {
          anio: process.env.VUE_APP_ANIO,
        };
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/?anio=${obj.anio}&nombre=${this.nombre}`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );
            console.log("Estado buttonssssss", this.userPermissions);
        if (res.data) {
          this.borrador = res.data.info.content;
        }
        this.cargado_borrador=true
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.obtenerBorrador();
  },
};
</script>

<style scoped>
.row {
  margin: 0;
}
.btn-one {
  margin-right: 20px;
}

.btn-direction-flex {
  text-align: end;
}

.title {
  margin-top: 20px;
  margin-bottom: 21px;
  text-align: center;
  color: #052333;
}

.title > h5 {
  font-weight: bold;
}
@media screen and (max-width: 784px) {
  .btn-one {
    font-size: 11px;
    margin-right: 5px;
  }
  .btn-two {
    font-size: 11px;
  }
}

@media screen and (max-width: 569px) {
  .btn-one {
    font-size: 10px;
    margin-right: 5px;
    width: 90px;
  }
  .btn-two {
    font-size: 10px;
    width: 90px;
  }
}

@media screen and (max-width: 417px) {
  .one {
    display: none;
  }
  .btn-one {
    font-size: 10px;
    margin-right: 5px;
    width: 90px;
    margin-bottom: 15px;
  }
  .btn-two {
    font-size: 10px;
    width: 90px;
    position: relative;
    top: -6px;
  }
  .btn-direction-flex {
    text-align: start;
    margin-left: 30px;
  }
}
</style>
